import AxiosAPI from '../../../utils/AxiosAPI';

export const handelLoadGwTrans = (authInfo, status, dateStart, dateEnd) =>
    new Promise((resolve, reject) => {
        AxiosAPI(authInfo)
            .setPath(`/api/finance/transactions/gateway/`, { status, dateStart, dateEnd })
            .get()
            .then(({ data }) => {
                if (data.error === 0) {
                    resolve(data);
                } else {
                    reject(Error(data.message));
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleGtwTranStatusUpdate = (authInfo, gTranId, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI(authInfo)
            .setPath(`/api/finance/transactions/gateway/${gTranId}/update-status/ `)
            .post(formData)
            .then(({ data }) => {
                if (data.error === 0) {
                    resolve(data);
                } else {
                    reject(Error(data.message));
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
